import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/unit-measures',
    name: 'unit-measure',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/unit-measure/index.vue')
  },
  {
    path: '/unit-measures/create',
    name: 'unit-measure-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/unit-measure/create.vue')
  },
  {
    path: '/unit-measures/:id',
    name: 'unit-measure-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/unit-measure/edit.vue'),
    props: route => ({ editData: route.params.editData })
  }
]
